import {
  STUDENT_FIELD_TYPES,
  STUDENT_FIELD_TYPE_OPTIONS,
  getStudentFieldTypeLabel,
  isTruthySetting,
} from './studentProfileFields'

export const PARENT_PROFILE_FIELDS_SETTINGS_KEY = 'parentProfileFieldsSettings'

export const PARENT_CUSTOM_FIELDS_SETTING_KEY = 'customFieldsParents'

export const PARENT_FIELD_TYPES = STUDENT_FIELD_TYPES

export const PARENT_FIELD_TYPE_OPTIONS = STUDENT_FIELD_TYPE_OPTIONS

export const PARENT_PROFILE_SYSTEM_FIELDS = [
  {
    id: 'name',
    label: 'ФИО',
    type: PARENT_FIELD_TYPES.TEXT,
    valueKey: 'name',
    activeLocked: true,
    canRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: true,
    defaultProfileEditable: true,
    fixed: true,
  },
  {
    id: 'phone',
    label: 'Номер телефона',
    type: PARENT_FIELD_TYPES.PHONE,
    valueKey: 'phone',
    activeSetting: 'showPhoneParents',
    canRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: true,
    defaultProfileEditable: true,
    fixed: true,
  },
  {
    id: 'email',
    label: 'Почта',
    type: PARENT_FIELD_TYPES.TEXT,
    valueKey: 'email',
    activeSetting: 'showEmailParents',
    canRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: true,
    defaultProfileEditable: true,
    fixed: true,
  },
  {
    id: 'login',
    label: 'Логин',
    type: PARENT_FIELD_TYPES.TEXT,
    valueKey: 'login',
    defaultActive: false,
    canRequired: true,
    defaultRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: false,
    canProfileEditable: true,
    defaultProfileEditable: true,
  },
  {
    id: 'id',
    label: 'ID',
    type: PARENT_FIELD_TYPES.TECHNICAL,
    activeSetting: 'showIdParents',
    canRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: false,
    canProfileEditable: false,
  },
  {
    id: 'socialLink',
    label: 'Ссылка на соц. сеть',
    type: PARENT_FIELD_TYPES.LINK,
    valueKey: 'link_to_vk',
    activeSetting: 'showSocialLinkParents',
    canRequired: true,
    defaultRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: true,
    defaultProfileEditable: true,
  },
  {
    id: 'about',
    label: 'О себе',
    type: PARENT_FIELD_TYPES.TEXTAREA,
    valueKey: 'about',
    activeSetting: 'showAboutParents',
    canRequired: true,
    defaultRequired: false,
    canProfileVisible: true,
    defaultProfileVisible: true,
    canProfileEditable: true,
    defaultProfileEditable: true,
  },
  {
    id: 'aboutParent',
    label: 'Информация о родителе',
    type: PARENT_FIELD_TYPES.TEXTAREA,
    valueKey: 'about_parent',
    activeSetting: 'showParentInfoParents',
    canRequired: true,
    defaultRequired: false,
    canProfileVisible: false,
    canProfileEditable: false,
  },
]

const PARENT_API_FIELD_ID_BY_NAME = {
  name: 'name',
  phone: 'phone',
  email: 'email',
  login: 'login',
  id: 'id',
  link_to_vk: 'socialLink',
  about: 'about',
  about_parent: 'aboutParent',
}

const PARENT_SYSTEM_FIELD_BY_ID = PARENT_PROFILE_SYSTEM_FIELDS.reduce(
  (acc, field) => {
    acc[field.id] = field
    return acc
  },
  {},
)

const safeJsonParse = (value, fallback) => {
  if (Array.isArray(value) || (value && typeof value === 'object')) return value
  if (!value || typeof value !== 'string') return fallback

  try {
    return JSON.parse(value)
  } catch {
    return fallback
  }
}

const getFiniteNumber = (value, fallback) => {
  if (value === undefined || value === null || value === '') return fallback
  const number = Number(value)
  return Number.isFinite(number) ? number : fallback
}

export const parseParentFieldSettings = (value) => {
  const parsed = safeJsonParse(value, {})

  return {
    required:
      parsed?.required && typeof parsed.required === 'object'
        ? parsed.required
        : {},
    profileVisible:
      parsed?.profileVisible && typeof parsed.profileVisible === 'object'
        ? parsed.profileVisible
        : {},
    profileEditable:
      parsed?.profileEditable && typeof parsed.profileEditable === 'object'
        ? parsed.profileEditable
        : {},
    employeeVisible:
      parsed?.employeeVisible && typeof parsed.employeeVisible === 'object'
        ? parsed.employeeVisible
        : {},
    salesManagerVisible:
      parsed?.salesManagerVisible &&
      typeof parsed.salesManagerVisible === 'object'
        ? parsed.salesManagerVisible
        : {},
    teacherVisible:
      parsed?.teacherVisible && typeof parsed.teacherVisible === 'object'
        ? parsed.teacherVisible
        : {},
    sorting:
      parsed?.sorting && typeof parsed.sorting === 'object'
        ? parsed.sorting
        : {},
  }
}

export const normalizeParentCustomField = (field, index = 0) => {
  const rawType = field?.type ?? PARENT_FIELD_TYPES.TEXT
  const type = Object.values(PARENT_FIELD_TYPES).includes(rawType)
    ? rawType
    : PARENT_FIELD_TYPES.TEXT
  const fallbackName = `custom_parent_${Date.now()}_${index}`

  return {
    id: field?.id ?? field?.name ?? fallbackName,
    name: String(field?.name ?? fallbackName),
    label: String(field?.label ?? field?.name ?? ''),
    type,
    value_options: Array.isArray(field?.value_options)
      ? field.value_options
      : Array.isArray(field?.fields)
        ? field.fields.map((item) => item?.label ?? item?.name).filter(Boolean)
        : [],
    is_active: isTruthySetting(field?.is_active, true),
    required: isTruthySetting(field?.required ?? field?.is_required, false),
    profile_visible: isTruthySetting(field?.profile_visible, false),
    profile_editable:
      isTruthySetting(field?.profile_visible, false) &&
      isTruthySetting(field?.profile_editable, false),
    employee_visible: isTruthySetting(field?.employee_visible, true),
    sales_manager_visible: isTruthySetting(
      field?.sales_manager_visible,
      true,
    ),
    teacher_visible: isTruthySetting(field?.teacher_visible, true),
    sorting:
      field?.sorting === undefined || field?.sorting === null
        ? null
        : getFiniteNumber(field.sorting, index + 1),
    isCustom: true,
    is_system: false,
    can_active: isTruthySetting(field?.can_active, true),
    can_required: isTruthySetting(field?.can_required, true),
    can_profile_visible: isTruthySetting(field?.can_profile_visible, true),
    can_profile_editable: isTruthySetting(field?.can_profile_editable, true),
  }
}

const normalizeParentSystemField = (field, index = 0) => {
  const systemId =
    PARENT_API_FIELD_ID_BY_NAME[field?.name] ??
    PARENT_API_FIELD_ID_BY_NAME[field?.id] ??
    field?.name ??
    field?.id
  const baseField = PARENT_SYSTEM_FIELD_BY_ID[systemId]

  if (!baseField) return null

  return {
    ...baseField,
    profileFieldId: field.id,
    fieldName: field.name,
    label: String(field?.label ?? baseField.label),
    type: field?.type ?? baseField.type,
    value_options: field?.value_options ?? baseField.value_options,
    is_active: isTruthySetting(field?.is_active, true),
    required: isTruthySetting(field?.is_required, baseField.defaultRequired),
    profile_visible: isTruthySetting(
      field?.profile_visible,
      baseField.defaultProfileVisible,
    ),
    profile_editable:
      isTruthySetting(field?.profile_visible, baseField.defaultProfileVisible) &&
      isTruthySetting(field?.profile_editable, baseField.defaultProfileEditable),
    employee_visible: isTruthySetting(field?.employee_visible, true),
    sales_manager_visible: isTruthySetting(field?.sales_manager_visible, true),
    teacher_visible: isTruthySetting(field?.teacher_visible, true),
    can_active: isTruthySetting(field?.can_active, Boolean(baseField.activeSetting)),
    can_required: isTruthySetting(field?.can_required, baseField.canRequired),
    can_profile_visible: isTruthySetting(
      field?.can_profile_visible,
      baseField.canProfileVisible,
    ),
    can_profile_editable: isTruthySetting(
      field?.can_profile_editable,
      baseField.canProfileEditable,
    ),
    sorting:
      field?.sorting === undefined || field?.sorting === null
        ? index + 1
        : getFiniteNumber(field.sorting, index + 1),
    isCustom: false,
    is_system: true,
  }
}

export const parseParentCustomFields = (value) => {
  const parsed = safeJsonParse(value, [])
  if (!Array.isArray(parsed)) return []

  return parsed
    .filter((field) => !field?.is_system)
    .map(normalizeParentCustomField)
}

export const parseParentProfileApiFields = (value) => {
  const parsed = safeJsonParse(value, [])
  if (!Array.isArray(parsed)) return { systemFields: [], customFields: [] }

  return parsed.reduce(
    (acc, field, index) => {
      if (field?.is_system) {
        const systemField = normalizeParentSystemField(field, index)
        if (systemField) acc.systemFields.push(systemField)
        return acc
      }

      acc.customFields.push(normalizeParentCustomField(field, index))
      return acc
    },
    { systemFields: [], customFields: [] },
  )
}

export const serializeParentCustomFields = (fields) =>
  JSON.stringify(parseParentCustomFields(fields))

export const getParentFieldTypeLabel = getStudentFieldTypeLabel

export const getParentFieldSettingValue = (field, settings, key) => {
  if (!field) return false

  const safeSettings = {
    ...settings,
    required: settings?.required ?? {},
    profileVisible: settings?.profileVisible ?? {},
    profileEditable: settings?.profileEditable ?? {},
    employeeVisible: settings?.employeeVisible ?? {},
    salesManagerVisible: settings?.salesManagerVisible ?? {},
    teacherVisible: settings?.teacherVisible ?? {},
  }

  if (field.profileFieldId || field.is_system) {
    if (key === 'required') return isTruthySetting(field.required)
    if (key === 'profileVisible') return isTruthySetting(field.profile_visible)
    if (key === 'profileEditable')
      return (
        isTruthySetting(field.profile_visible) &&
        isTruthySetting(field.profile_editable)
      )
    if (key === 'employeeVisible') return isTruthySetting(field.employee_visible, true)
    if (key === 'salesManagerVisible')
      return isTruthySetting(field.sales_manager_visible, true)
    if (key === 'teacherVisible') return isTruthySetting(field.teacher_visible, true)
    return false
  }

  if (field.isCustom) {
    if (key === 'required') return isTruthySetting(field.required)
    if (key === 'profileVisible') return isTruthySetting(field.profile_visible)
    if (key === 'profileEditable')
      return (
        isTruthySetting(field.profile_visible) &&
        isTruthySetting(field.profile_editable)
      )
    if (key === 'employeeVisible')
      return isTruthySetting(field.employee_visible, true)
    if (key === 'salesManagerVisible')
      return isTruthySetting(field.sales_manager_visible, true)
    if (key === 'teacherVisible')
      return isTruthySetting(field.teacher_visible, true)
    return false
  }

  if (key === 'required') {
    if (!field.canRequired) return false
    return isTruthySetting(safeSettings.required[field.id], field.defaultRequired)
  }

  if (key === 'profileVisible') {
    if (!field.canProfileVisible) return false
    return isTruthySetting(
      safeSettings.profileVisible[field.id],
      field.defaultProfileVisible,
    )
  }

  if (key === 'profileEditable') {
    if (!field.canProfileEditable) return false
    return (
      getParentFieldSettingValue(field, safeSettings, 'profileVisible') &&
      isTruthySetting(
        safeSettings.profileEditable[field.id],
        field.defaultProfileEditable,
      )
    )
  }

  if (key === 'employeeVisible') {
    return isTruthySetting(safeSettings.employeeVisible[field.id], true)
  }

  if (key === 'salesManagerVisible') {
    return isTruthySetting(safeSettings.salesManagerVisible[field.id], true)
  }

  if (key === 'teacherVisible') {
    return isTruthySetting(safeSettings.teacherVisible[field.id], true)
  }

  return false
}

export const isParentFieldActive = (field, platformSettings) => {
  if (field.activeLocked) return true
  if (field.profileFieldId || field.is_system)
    return isTruthySetting(field.is_active, true)
  if (field.isCustom) return isTruthySetting(field.is_active, true)
  if (!field.activeSetting) return true
  return isTruthySetting(platformSettings?.[field.activeSetting], true)
}

export const isTextareaParentField = (field) =>
  field.type === PARENT_FIELD_TYPES.TEXTAREA

export const getParentProfileFields = (
  platformSettings = {},
  customFieldsSource,
  includeInactive = false,
) => {
  const settings = platformSettings ?? {}
  const fieldSettings = parseParentFieldSettings(
    settings[PARENT_PROFILE_FIELDS_SETTINGS_KEY],
  )
  const apiFields = parseParentProfileApiFields(customFieldsSource)
  const customFields = customFieldsSource
    ? apiFields.customFields
    : parseParentCustomFields(settings[PARENT_CUSTOM_FIELDS_SETTING_KEY])
  const systemFields = apiFields.systemFields.length
    ? apiFields.systemFields
    : PARENT_PROFILE_SYSTEM_FIELDS.map((field) => ({
        ...field,
        isCustom: false,
      }))
  const allFields = [...systemFields, ...customFields]
  let regularSorting = 0
  let textAreaSorting = 0

  return allFields
    .filter(
      (field) => includeInactive || isParentFieldActive(field, platformSettings),
    )
    .map((field) => {
      const fallbackSorting = isTextareaParentField(field)
        ? (textAreaSorting += 1)
        : (regularSorting += 1)

      return {
        ...field,
        defaultSorting: fallbackSorting,
        sorting: field.isCustom
          ? getFiniteNumber(field.sorting, fallbackSorting)
          : field.profileFieldId || field.is_system
            ? getFiniteNumber(field.sorting, fallbackSorting)
            : getFiniteNumber(
                fieldSettings.sorting[field.id],
                fallbackSorting,
              ),
        required: getParentFieldSettingValue(field, fieldSettings, 'required'),
        profile_visible: getParentFieldSettingValue(
          field,
          fieldSettings,
          'profileVisible',
        ),
        profile_editable: getParentFieldSettingValue(
          field,
          fieldSettings,
          'profileEditable',
        ),
        employee_visible: getParentFieldSettingValue(
          field,
          fieldSettings,
          'employeeVisible',
        ),
        sales_manager_visible: getParentFieldSettingValue(
          field,
          fieldSettings,
          'salesManagerVisible',
        ),
        teacher_visible: getParentFieldSettingValue(
          field,
          fieldSettings,
          'teacherVisible',
        ),
      }
    })
    .sort((a, b) => {
      const aTextarea = isTextareaParentField(a)
      const bTextarea = isTextareaParentField(b)
      if (aTextarea !== bTextarea) return aTextarea ? 1 : -1
      return Number(a.sorting ?? a.defaultSorting) - Number(b.sorting ?? b.defaultSorting)
    })
}

export const getParentCustomFieldValues = (parent = {}) => {
  const source = parent ?? {}
  const value =
    source.custom_fields ??
    source.userProfile?.custom_fields ??
    source.userProfile?.customFields ??
    {}
  const parsed = safeJsonParse(value, {})

  return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
    ? parsed
    : {}
}

export const isValidParentLinkValue = (value) => {
  const trimmed = String(value ?? '').trim()
  if (!trimmed) return true

  try {
    const url = new URL(
      /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`,
    )
    return Boolean(url.hostname && url.hostname.includes('.'))
  } catch {
    return false
  }
}
